<div class="item-grid-container">
    <div class="carrier-promotions-form">
         <form
           [formGroup]="bannerPromoForm"
           (ngSubmit)="onBannerFormSubmit($event)"
         >
           <div class="form-inner buss-info-details content-details-blk">
             <div class="row">
               <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div class="row">
                  <div
                    class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center"
                  >
                    <h4 class="form-item-label mb-0" translate>
                      Video Header<span class="required">*</span>
                    </h4>
                  </div>
                  <div
                    class="col-lg-8 col-md-8 col-sm-8 col-xs-12 align-self-center"
                  >
                    <div class="form-item-input">
                      <mat-form-field appearance="outline" class="w-70">
                        <input
                          matInput
                          type="text"
                          placeholder="Enter the video header"
                          formControlName="headerName"
                          required
                        />
                      </mat-form-field>
                      <div *ngIf="f.headerName.touched && f.headerName.errors?.required">
                        <mat-hint class="text-danger ms-2">
                          Video Header is Required</mat-hint
                        >
                      </div>
                    </div>
                  </div>
                </div>
                 <div class="row">
                   <div
                     class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center"
                   >
                     <h4 class="form-item-label mb-0" translate>
                       Video link<span class="required">*</span>
                     </h4>
                   </div>
                   <div
                     class="col-lg-8 col-md-8 col-sm-8 col-xs-12 align-self-center"
                   >
                     <div class="form-item-input">
                       <mat-form-field appearance="outline" class="w-70">
                         <input
                           matInput
                           type="text"
                           placeholder="Enter the video link"
                           formControlName="videoUrl"
                           required
                         />
                       </mat-form-field>
                      <div *ngIf="f.videoUrl.touched && f.videoUrl.errors?.required">
                        <mat-hint class="text-danger ms-2">
                          Video URL is Required</mat-hint
                        >
                      </div>
                       <div *ngIf="f.videoUrl.invalid && f.videoUrl.touched && f.videoUrl.dirty && f.videoUrl.value">
                          <mat-hint class="text-danger ms-2">
                            Invalid URL Format</mat-hint
                          >
                      </div>
                     </div>
                   </div>
                 </div>
                 <div class="row">
                   <div
                     class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center"
                   >
                     <h4 class="form-item-label mb-0" translate>
                       Status<span class="required">*</span>
                     </h4>
                   </div>
                   <div
                     class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center"
                   >
                     <div class="form-item-input">
                       <mat-form-field appearance="outline">
                            <mat-select formControlName="status">
                              <mat-option value="Active">
                                Active
                              </mat-option>
                              <mat-option value="InActive">
                                InActive
                              </mat-option>
                            </mat-select>
                       </mat-form-field>
                     </div>
                   </div>
                 <div
                     class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center"
                   >
                     <h4 class="form-item-label mb-0" translate>
                       Language Preference<span class="required">*</span>
                     </h4>
                   </div>
                   <div class="  form-item-input col-lg-3 col-md-3 col-sm-3 col-xs-12" style="margin-left: -4%;">
                     <mat-form-field appearance="outline" >
                        <mat-select formControlName="language">
                        <mat-option value="English">
                          English
                        </mat-option>
                        <mat-option value="Spanish">
                          Spanish
                        </mat-option>
                      </mat-select>
                     </mat-form-field>
                   </div>
                 </div>
                 <div class="row">
                  <div
                     class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center"
                   >
                     <h4 class="form-item-label mb-0" translate>
                       Creation Date<span class="required">*</span>
                     </h4>
                   </div>
                   <div
                     class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center"
                   >
                  <mat-form-field appearance="outline" style="width: 90% !important;">
                    <input
                      matInput
                      [matDatepicker]="picker"
                      [min]="today"
                      formControlName="promotionCreatdttm"
                      placeholder="MM/DD/YYYY"
                    />
                    <mat-datepicker-toggle matSuffix [for]="picker">
                      <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                    </mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>                  
                   </div>
                 </div>
                 </div>
             </div>
             <div class="form-footer">
                <ul class="list-inline text-center">
                  <li class="list-inline-item">
                    <button
                      mat-raised-button
                      color="primary"
                      type="submit"
                      class="rounded-0"
                      [disabled]="checkSubmitDisplayed()"
                    >
                      <span translate class="translate">save</span>
                    </button>
                  </li>
                  <li class="list-inline-item">
                    <button
                      mat-stroked-button
                      color="primary"
                      type="button"
                      class="rounded-0"
                      (click)="onCancel()"
                    >
                      <span translate class="translate">pages.newRetailer.cancel</span>
                    </button>
                  </li>
                  <li class="list-inline-item"></li>
                </ul>
              </div>
           </div>
         </form>
       </div>
   </div>
   